import { Box, Stack, styled } from '@/theme/index';

export const BannerContainer = styled(Stack)(({ theme }) => ({
  width: ' 100%',
  borderRadius: '5px',
  textAlign: 'left',
  border: '1px solid rgb(204,200,223)',
  backgroundColor: theme.palette.secondary.main,
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  flexDirection: 'row',
  margin: `${theme.spacing(1)} 0 ${theme.spacing(3.75)} 0`,
}));

export const BannerIconWrapper = styled(Box)(({ theme }) => ({
  width: 50,
  height: 50,
  padding: theme.spacing(1.25),
  marginRight: theme.spacing(3.75),
  background: 'center / contain no-repeat',

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2.5),
    marginRight: theme.spacing(1.5),
  },
}));
